import React from "react";
import { Navbar } from "react-bulma-components";
import {useSelector} from "react-redux";
import {getCostCentresData, getDataFresh} from "../../state/selectors";
import {useCostCentreData} from "../../hooks/useCostCentreData";
import {useHistory} from "react-router";

function TransactionsNav({profile, transactionType, setMenuActive}) {
  const { push } = useHistory();
  const transMapping = {income: "Income", expenses: "Expenses"}


  return <Navbar.Dropdown>
    <Navbar.Item
          onClick={() => {
            push("/po");
            setMenuActive(false);
          }}
        >
          Workshop Expenses
    </Navbar.Item>
    <Navbar.Item
        onClick={() => {
            push("/fixedexpense");
            setMenuActive(false);
        }}
    >
        Fixed Expenses
    </Navbar.Item>
    <Navbar.Item onClick={() => push(`/${transactionType}`)}>
      All {transMapping[transactionType]}
    </Navbar.Item>
  </Navbar.Dropdown>
}

export default TransactionsNav;
